import {Config} from "./config.model";
import {MAP, PollInfoRecord, PollResultRecord, TakerResultsSummary} from "./common.model";
import {PageInfo, PollListRecord} from "./author.model";
import {BtPoll, EntirePoll} from "./store.model";
import {Questions} from "../index";

/**
 * Response statuses
 */

export interface TakerResponseStatus {   // java TakerResponseStatus
    token: string;
    currentTime: number;
    state: string;
    questSetNum: number;   // current cursor (current set of questions) or null if not set yet
    startTime: number;     // time when started taking poll
    endTime: number;       // time when submitted poll responses
}

export interface AuthorResponseStatus {
    pollId: number;
    lockHolder: string;
}

export interface CommonResponseStatus extends TakerResponseStatus, AuthorResponseStatus {

}

/**
 * Response errors
 */

export interface ResponseError {
    field: string;
    message: string;
}

/**
 * Basic Response (except response record/records)
 */

export interface IBasicResponse {
    responseType?: string;               // see hbs.poll.constants.BasicResponseType in java
    status?: CommonResponseStatus; // Note: status is defined differently in java
    error?: string;                      // error message
    errors?: ResponseError[];            // validation errors
    uuid?: string;                       // error UUID
}

export class BasicResponse implements IBasicResponse {
    responseType: string;                  // see hbs.poll.constants.BasicResponseType in java
    status: CommonResponseStatus; // Note: status is defined differently in java
    error: string;                         // error message
    errors: ResponseError[];               // validation errors
    uuid: string;                          // error UUID
}

/**
 * Response record/records
 */

export interface ResponseRecord<T> extends IBasicResponse {
    _isValidation: boolean;         // ResponseRecord is validation response
    record?: T;                     // record
}

//export interface ResponseRecords<T> extends AuthorBasicResponse {
//  records? : T[];             // array of records
//}

// "/rest/config"
export interface ConfigResponse extends Config {    // java Map<String, Object>
}

// "/rest/taker/poll/{pollId}/get"
export class PollResponse extends BasicResponse {     // java TakerRecordResponse<TakerPollInfo>
    record: PollInfoRecord;
}

// "/rest/taker/poll/{pollId}/questions"
export class QuestionsResponse extends BasicResponse {  // java TakerSequenceResponseTaker
    questions: Questions;
    records: MAP[];
}

// "/rest/taker/poll/{pollId}/submit"
export class TakerValidationResponse extends QuestionsResponse { // java TakerRecordsResponse<R> or TakerSequenceResponse
}

// "/rest/taker/poll/{pollId}/submit"
export class TakerResultsResponse extends QuestionsResponse {   // java TakerResultsResponse
    takerResultsSummary: TakerResultsSummary;
    correctAnswers: MAP;   // Map<question #, Map<Subquestion #, CorrectAnswer>>
}

// "/rest/taker/poll/{pollId}/results"
export class PollResultsResponse extends BasicResponse {  // java TakerPollResultsResponse
    pollResultsSummary: MAP;
    respondedNumByQuestionAndSubq: {questNum: number, subqNum: number, responseCount: number}[];
    questions: MAP[];
    records: PollResultRecord[];
}

// "/rest/author/poll/list"
export class PollListResponse extends BasicResponse {
    records: PollListRecord[];
    pageInfo: PageInfo;
}

// "/rest/author/poll/{pollId}/get"
export class AuthorPollResponse implements ResponseRecord<BtPoll> {

    _isValidation: boolean;   // ResponseRecord is validation response
    responseType: string;     // response type
    uuid: string;             // error UUID
    error: string;            // error message
    errors: ResponseError[];  // validation errors
    record: BtPoll;           // record
    status: CommonResponseStatus;     // status

    static deserialize(json: any): AuthorPollResponse {
        let model: AuthorPollResponse = null;
        if (json) {
            model = Object.assign(new AuthorPollResponse(), json);
        }
        return model;
    }

}

// "/rest/author/poll/{pollId}/entire"  - returns all poll data including questions, etc
export class AuthorEntirePollResponse implements ResponseRecord<EntirePoll> {

    _isValidation: boolean;   // ResponseRecord is validation response
    responseType: string;     // response type
    uuid: string;             // error UUID
    error: string;            // error message
    errors: ResponseError[];  // validation errors
    record: EntirePoll;       // record
    status: CommonResponseStatus;     // status

    static deserialize(json: any): AuthorEntirePollResponse {
        let model: AuthorEntirePollResponse = null;
        if (json) {
            model = Object.assign(new AuthorEntirePollResponse(), json);
        }
        return model;
    }

}

export class ResponsesNum extends BasicResponse {
    record: number;    // number of poll responses
}


// TODO: vs ResponseRecords
export class AuthorRecordsResponse extends BasicResponse {
    records: MAP[];
}
